import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[shIndeterminate]',
    standalone: true
})
export class ShIndeterminateDirective {
    @Input()
    set shIndeterminate(value: boolean) {
        this.elem.nativeElement.indeterminate = value;
        if (value) {
            this.elem.nativeElement.setAttribute('data-indeterminate', true);
        } else {
            this.elem.nativeElement.removeAttribute('data-indeterminate');
        }
    }

    constructor(private readonly elem: ElementRef) {}
}
